if (!customElements.get('zz-product-variant-tabs')) {
    class ProductVariantTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.variant-tabs__tab');
        this.panels = this.querySelectorAll('.variant-tabs__content');
        this.currentVariantId = null;

      }

      connectedCallback() {
        this.setupTabs();
        this.setupColorSwatches();
        this.setupAddToCart();
        this.initializeFirstVariant();
        this.initializeSwiper();
      }

      initializeSwiper() {
        document.addEventListener('DOMContentLoaded', () => {
          const swiperContainer = this.querySelector('.variant-tabs-swiper .swiper-container');
          if (!swiperContainer) return;

          // Initialize Swiper
          this.swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
              },
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });

        });
        
      }

      updateSwiper(images) {
        if (!this.swiper || !images ) return;
        console.log('photoList-images', images)
        try {
          const parsedImages = JSON.parse(images);
          console.log('parsedImages', parsedImages)
          // Remove existing slides
          this.swiper.removeAllSlides();

          // Add new slides
          parsedImages.forEach(imageUrl => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = 'Product image';
            img.className = 'swiper-slide-image';
            slide.appendChild(img);
            this.swiper.appendSlide(slide);
          });

          // Update swiper
          this.swiper.update();
          this.swiper.slideTo(0, 0);
        } catch (error) {
          console.error('Invalid JSON string:', images);
          return;
        }
        
      }

      initializeFirstVariant() {
        const firstPanel = this.querySelector('.variant-tabs__content.active');
        
        if (firstPanel) {
          const tabActions = firstPanel.querySelector('.variant-tabs__actions');
          if (tabActions && tabActions.dataset.variantId) {
            this.currentVariantId = tabActions.dataset.variantId;
            return;
          }
          const firstSwatch = firstPanel.querySelector('.variant-tabs__color-swatch:not(.variant-unavailable)');
          if (firstSwatch) {
            this.currentVariantId = firstSwatch.dataset.variantId;
          }
        }
        
      }

      setupTabs() {
        // Get the tabs container for scrolling
        this.tabsContainer = this.querySelector('.variant-tabs__tabs-content');
        
        // Get left and right buttons and store as instance properties
        this.leftButton = this.querySelector('.variant-tabs__tabs-left');
        this.rightButton = this.querySelector('.variant-tabs__tabs-right');
        
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const tabId = tab.dataset.tab;
            
            this.tabs.forEach(t => t.classList.remove('active'));
            this.panels.forEach(p => p.classList.remove('active'));
            
            tab.classList.add('active');
            const panel = this.querySelector(`[data-panel="${tabId}"]`);
            if (panel) {
              panel.classList.add('active');
              const tabActions = panel.querySelector('.variant-tabs__actions');
              if (tabActions && tabActions.dataset.variantId) {
                this.currentVariantId = tabActions.dataset.variantId;
                const photoList = tabActions.dataset.photoList;
                 this.updateSwiper(photoList);
              } else {
                const firstSwatch = panel.querySelector('.variant-tabs__color-swatch:not(.variant-unavailable)');
                if (firstSwatch) {
                    this.selectCardOptionSwatch(firstSwatch, panel);
                }

              }
              
            }
            
            // Scroll the active tab into view, centered if possible
            this.scrollTabIntoView(tab);
            
            // Update button states after tab change
            this.updateButtonStates();
          });
        });

        // Add left and right tab navigation
        if (this.leftButton) {
          this.leftButton.addEventListener('click', () => {
            this.switchTab(-1);
          });
        }

        if (this.rightButton) {
          this.rightButton.addEventListener('click', () => {
            this.switchTab(1);
          });
        }
        
        // Initialize button states on load
        this.updateButtonStates();
      }

      scrollTabIntoView(tab) {
        if (!this.tabsContainer) return;
        
        const tabRect = tab.getBoundingClientRect();
        const containerRect = this.tabsContainer.getBoundingClientRect();
        
        // Calculate the desired scroll position to center the tab
        const scrollLeft = this.tabsContainer.scrollLeft + tabRect.left - containerRect.left - containerRect.width / 2 + tabRect.width / 2;
        
        // Animate the scroll
        this.tabsContainer.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }

      switchTab(direction) {
        const activeTabIndex = Array.from(this.tabs).findIndex(tab => tab.classList.contains('active'));
        let newIndex;

        if (direction === -1) {
          // Move left - only if not already on the first tab
          if (activeTabIndex > 0) {
            newIndex = activeTabIndex - 1;
            this.tabs[newIndex].click();
          }
        } else {
          // Move right - only if not already on the last tab
          if (activeTabIndex < this.tabs.length - 1) {
            newIndex = activeTabIndex + 1;
            this.tabs[newIndex].click();
          }
        }
      }

      updateButtonStates() {
        const activeTabIndex = Array.from(this.tabs).findIndex(tab => tab.classList.contains('active'));
        
        // Disable left button if on first tab
        if (this.leftButton) {
          if (activeTabIndex === 0) {
            this.leftButton.classList.add('disabled');
            this.leftButton.setAttribute('disabled', 'disabled');
          } else {
            this.leftButton.classList.remove('disabled');
            this.leftButton.removeAttribute('disabled');
          }
        }
        
        // Disable right button if on last tab
        if (this.rightButton) {
          if (activeTabIndex === this.tabs.length - 1) {
            this.rightButton.classList.add('disabled');
            this.rightButton.setAttribute('disabled', 'disabled');
          } else {
            this.rightButton.classList.remove('disabled');
            this.rightButton.removeAttribute('disabled');
          }
        }
      }

      setupColorSwatches() {
        this.panels.forEach(panel => {
          const swatches = panel.querySelectorAll('.variant-tabs__color-swatch');
          
          swatches.forEach(swatch => {
            if (swatch.dataset.available === 'true') {
              swatch.addEventListener('click', () => {
                this.selectCardOptionSwatch(swatch, panel);
              });
            }
          });
        });
      }

      selectCardOptionSwatch(swatch, panel) {
        const swatches = panel.querySelectorAll('.variant-tabs__color-swatch');
        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');

        this.currentVariantId = swatch.dataset.variantId;
        const colorName = swatch.dataset.colorName;
        const photoList = swatch.dataset.photoList;

        const selectedColorSpan = panel.querySelector('[data-selected-color]');
        if (selectedColorSpan) {
          selectedColorSpan.textContent = colorName;
        }

       
         // 选择颜色价格与配置都相同本期不用修改
        //  const priceElement = panel.querySelector('.variant-tabs__card-price');
        //     if (priceElement && price) {
        //     const formattedPrice = new Intl.NumberFormat('en-US', {
        //         style: 'currency',
        //         currency: '{{ cart.currency.iso_code }}'
        //     }).format(price / 100);
        //     priceElement.textContent = formattedPrice;
        //     } 

        
        this.updateSwiper(photoList);
        

        const addToCartBtn = panel.querySelector('.add-to-cart');
        const isAvailable = swatch.dataset.available === 'true';
        if (addToCartBtn) {
          addToCartBtn.disabled = !isAvailable;
          addToCartBtn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
        }
      }

      setupAddToCart() {
        const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const addToCartButtons = this.querySelectorAll('.add-to-cart');
        
        addToCartButtons.forEach(button => {
          button.addEventListener('click', () => {
            if (!this.currentVariantId || button.disabled) return;

            button.textContent = 'Adding...';
            button.disabled = true;

            const formData = {
              items: [{
                id: this.currentVariantId,
                quantity: 1
              }],
              sections: 'cart-drawer,cart-icon-bubble',
            };

            fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                "Accept":"application/javascript"
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              if (response.status && response.status === 429) {
                window.location.href = window.location.href;
                return;
              }
              return response.json();
            })
            .then(response => {
              console.log('AddToCartResponse', response)
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: this.currentVariantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              } else {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: this.currentVariantId,
                  cartData: response,
                });
              }
              
              if (!cartDrawer) {
                window.location = window.routes.cart_url;
                return;
              }
              if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
              cartDrawer.renderContents(response);
          
            
            })
            .catch(error => {
              console.error('AddToCartError:', error);
            })
            .finally(() => {
              button.textContent = 'Add to cart';
              button.disabled = false;
            });
          });
        });
      }
    }

    customElements.define('zz-product-variant-tabs', ProductVariantTabs);
}